import api from "../api/client";

function normalizeLookupItems(data) {
  return Array.isArray(data)
    ? [...data].sort((left, right) => (left.name || "").localeCompare(right.name || ""))
    : [];
}

export async function loadActivityLookups() {
  const [grantsResult, implementorsResult, pillarsResult] = await Promise.allSettled([
    api.get("/grants"),
    api.get("/implementors"),
    api.get("/pillars")
  ]);

  return {
    grants: grantsResult.status === "fulfilled" ? normalizeLookupItems(grantsResult.value.data) : [],
    implementors: implementorsResult.status === "fulfilled" ? normalizeLookupItems(implementorsResult.value.data) : [],
    pillars: pillarsResult.status === "fulfilled" ? normalizeLookupItems(pillarsResult.value.data) : [],
    hasLookupError:
      grantsResult.status === "rejected" ||
      implementorsResult.status === "rejected" ||
      pillarsResult.status === "rejected"
  };
}
